import { on } from 'delegated-events'
import { slideToggle } from '../common/slide'

const fn = {
    init: () => {
        on('click', '.archive-item .title', fn.handleAccordian)

        if (window.location.hash) {
            if (document.querySelector('.' + window.location.hash.substring(1))) {
                let parent = document.querySelector('.' + window.location.hash.substring(1))
                parent.firstElementChild.classList.remove('closed')
                parent.querySelector('.archive-content').classList.remove('hidden')
            }
        }

    },

    handleAccordian: (e) => {
        e.preventDefault()
        var target = e.target;

        var item = target.closest('.archive-item')
        var title = target.closest('.title')

        if (title.classList.contains('closed')) {
            title.classList.remove('closed')
            var img = title.getElementsByTagName('img')[0]
            img.style.transform = 'rotate(180deg)';
        }
        else {
            title.classList.add('closed')
            var img = title.getElementsByTagName('img')[0]
            img.style.transform = 'rotate(0deg)';
        }

        var contents = item.getElementsByClassName('archive-content')
        var content = contents[0]
        slideToggle(content)

    }
}

export default {
    can: () => document.querySelector('.pagetype-archivepage') || document.querySelector('.element-archiveselement'),
    run: fn.init,
}
